import React from "react";

const LoadingSpinner = () => {
  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <p>Loading...</p>
    </div>
  );
};

export default LoadingSpinner;
